<template>
    <el-radio v-bind="$attrs" class="rt-radio"> <slot /> </el-radio>
</template>

<script>
export default {
  name: 'RtRadio'
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-radio {
  @{deep} {
    .el-radio__inner {
      width: 16px;
      height: 16px;
      background: #fff;
      &::after {
        width: 8px;
        height: 8px;
        background-color: #1890FF;
      }
    }
    .el-radio__input.is-disabled{
      .el-radio__inner {
        background-color: #f5f7fa;
      }
    }
    .el-radio__label {
      padding-left: 8px;
      color: #143e81;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtRadio.vue?47611abe